import $$ from 'cmn-utils';


// 微信登录
export async function wechatLogin(payload) {
  return $$.post('/wechatLogin', payload);
}

// 绑定终端
export async function addBindClient(payload) {   
  return $$.post('/addBindClient', payload);
}




// WEBPACK FOOTER //
// ./src/routes/System/Wechat/service/index.js